<script>
import {defineComponent} from 'vue'
import TicketQueue from "@/components/Tickets/widgets/TicketQueue.vue";
import TicketChat from "@/components/Tickets/widgets/TicketChat.vue";

export default defineComponent({
  name: "LiveChats",
  components: {TicketChat, TicketQueue},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
})
</script>

<template>
  <div>
    <Breadcrumbs main="LiveChats" title="Live Чаты"/>
    <b-container fluid class="live-chats-container">
      <b-row class="g-3 h-100">
        <b-col cols="12" md="4" lg="3" class="queue-col">
          <TicketQueue/>
        </b-col>
        <b-col cols="12" md="8" lg="9" class="chat-col">
          <TicketChat/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped lang="scss">
.live-chats-container {
  padding: 1rem;
  height: calc(100vh - 120px);
}

.queue-col,
.chat-col {
  height: 100%;
}
</style>